import { NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { DialogData } from '../../dialog/dialog-injector';
import { DialogComponentI } from '../../dialog/dialog.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ConfirmDialogVariant } from '../dialogs.types';

type Record = { name: string };

type DialogInputData = {
  records: Record[];
};

@Component({
  selector: 'rt-protected-controls-dialog',
  templateUrl: './protected-controls-dialog.component.html',
  standalone: true,
  imports: [ConfirmDialogComponent, NgIf, NgFor, TranslatePipe],
})
export class ProtectedControlsDialogComponent implements DialogComponentI<{}, boolean> {
  public readonly ConfirmDialogVariant = ConfirmDialogVariant;

  constructor(@Inject(DialogData) public data: DialogInputData) {}

  public trackBy(index: number, report: Record): any {
    return report.name;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(): void {}
}
